import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import NotasBlopedView from './NotasBlopedView';
import * as ROUTES from '../../../router/Routes';

const NotasBlopedModule = () => {
  return (
    <ContainerTemplate active={ROUTES.notasBloped} routes={[ROUTES.notas]}>
      <NotasBlopedView />
    </ContainerTemplate>
  );
};

export default NotasBlopedModule;
